import { toOriginal } from "./timeline.js"

/**
 * Pro publishes chapters and CTAs on the assembled-audio timeline and the
 * transcript on the original timeline. These project each onto the timeline
 * of the element that is playing: "video" = original, "audio" = assembled.
 */
export function projectCtas(ctas, { mode, insertions }) {
    if (!Array.isArray(ctas)) {
        return []
    }

    if (mode !== "video") {
        return ctas
    }

    return ctas.map((cta) => ({ ...cta, start: toOriginal(cta.start, insertions), end: toOriginal(cta.end, insertions) }))
}

/**
 * Index of the last item whose start is at or before `seconds`, or -1.
 * Items must be sorted by start.
 */
export function activeIndex(items, seconds) {
    let index = -1

    for (let i = 0; i < items.length; i++) {
        if (items[i].start > seconds) {
            break
        }

        index = i
    }

    return index
}
